// ================================================================
//  bizEventPicker
//  Flat checkbox list of a profile's biz events (name + description),
//  with Select All / Clear All — shared by the Create wizard's "Biz
//  Events" step and the Edit wizard's "Biz Events" tab so the UI/logic
//  exists once. Visual idiom (checkbox-row-with-description, paired
//  Select All/Clear All buttons) mirrors home/main-menu/users/tabs/
//  user-management/role-picker/role-explorer-picker.html's own
//  .rep-checkbox/.rep-action-btn--green/--red, just flattened (no tree/
//  search/cascade — this is a flat list).
//
//  Bindings:
//    - events      : '<' the profile's biz events, as returned by
//                    BusinessEventsService#getAllForProfile —
//                    {biz_event_id, biz_event_name, biz_event_description,
//                    enabled}. Disabled events are still shown (and
//                    selectable) rather than hidden — the backend already
//                    independently skips disabled events when resolving
//                    live endpoints, so hiding them here would just be
//                    confusing when a saved selection includes one.
//    - selectedIds : '=' two-way bound array of selected biz_event_id
//                    strings — reassigned (never mutated in place) on
//                    every toggle/selectAll/clearAll so the parent's own
//                    model field stays in sync.
//    - capturedElsewhereBy : '<' optional map of biz_event_id -> [names of
//                    interceptors of this profile already capturing it] —
//                    purely informational (renders a badge naming them),
//                    the parent controller decides whether/how that affects
//                    the default selection, this component never uses it
//                    to block a row from being toggled.
// ================================================================

angular.module('bizmetryApp').component('bizEventPicker', {
    bindings: {
        events: '<',
        selectedIds: '=',
        capturedElsewhereBy: '<'
    },
    templateUrl: 'profile/tabs/biz-interceptors/biz-event-picker/biz-event-picker.html',
    controller: function () {
        var $ctrl = this;

        $ctrl.isSelected = function (event) {
            return !!event && !!$ctrl.selectedIds && $ctrl.selectedIds.indexOf(event.biz_event_id) !== -1;
        };

        $ctrl.toggle = function (event) {
            if (!event) { return; }
            var ids = $ctrl.selectedIds || [];
            var idx = ids.indexOf(event.biz_event_id);
            $ctrl.selectedIds = idx === -1
                ? ids.concat([event.biz_event_id])
                : ids.filter(function (id) { return id !== event.biz_event_id; });
        };

        $ctrl.selectAll = function () {
            $ctrl.selectedIds = ($ctrl.events || []).map(function (e) { return e.biz_event_id; });
        };

        $ctrl.clearAll = function () {
            $ctrl.selectedIds = [];
        };

        $ctrl.selectedCount = function () {
            return ($ctrl.selectedIds || []).length;
        };

        $ctrl.capturedElsewhereNames = function (event) {
            var names = event && $ctrl.capturedElsewhereBy && $ctrl.capturedElsewhereBy[event.biz_event_id];
            return names && names.length ? names.join(', ') : null;
        };
    }
});
